import { lazy, type ComponentType } from "react";
import Home from "@pages/Dashboard/Home";
import {
  CmsRedirectToEmailTemplatesTab,
  CmsRedirectToNotificationTemplatesTab,
  CmsRedirectToContactEnquiryTab,
  CmsRedirectToFaqTab,
  CmsRedirectToPagesTab,
  CmsRedirectToPromoCodeTab,
  CmsRedirectToReportIssueTab,
  CmsRedirectToSmsTemplatesTab,
  CmsRedirectToStateManagementTab,
  CmsRedirectToTrainingTab,
  CmsRedirectToTripCancelManagerTab,
  CmsRedirectToBannerTab,
} from "@pages/CmsManagement/RedirectToTab";

const UserProfiles = lazy(() => import("@pages/UserProfile"));
const Setting = lazy(() => import("@pages/Setting"));
const CmsManagement = lazy(() => import("@pages/CmsManagement"));
const BannerPage = lazy(() => import("@pages/Banner"));
const BlogAddPage = lazy(() => import("@pages/Blog/add"));
const BlogEditPage = lazy(() => import("@pages/Blog/edit"));
const FaqAddPage = lazy(() => import("@pages/Faq/add"));
const FaqEditPage = lazy(() => import("@pages/Faq/edit"));
const PageAddPage = lazy(() => import("@pages/Page/add"));
const PageEditPage = lazy(() => import("@pages/Page/edit"));
const GeoFence = lazy(() => import("@pages/GeoFence"));
const GeoFenceFormPage = lazy(() => import("@pages/GeoFence/FormPage"));
const Language = lazy(() => import("@pages/Language"));
const Admin = lazy(() => import("@pages/Admin"));
const AdminAdd = lazy(() => import("@pages/Admin/Add"));
const AdminView = lazy(() => import("@pages/Admin/View"));
const Customer = lazy(() => import("@pages/Customer"));
const CustomerAdd = lazy(() => import("@pages/Customer/Add"));
const CustomerView = lazy(() => import("@pages/Customer/View"));
const VehicleType = lazy(() => import("@pages/VehicleType"));
const FuelType = lazy(() => import("@pages/FuelType"));
const RideType = lazy(() => import("@pages/RideType"));
const VehicleCatalog = lazy(() => import("@pages/VehicleCatalog"));
const VehicleCategory = lazy(() => import("@pages/VehicleCategory"));
const Vehicle = lazy(() => import("@pages/Vehicle"));
const VehicleAdd = lazy(() => import("@pages/Vehicle/Add"));
const VehicleView = lazy(() => import("@pages/Vehicle/View"));
const Driver = lazy(() => import("@pages/Driver"));
const DriverAdd = lazy(() => import("@pages/Driver/Add"));
const DriverView = lazy(() => import("@pages/Driver/View"));
const Booking = lazy(() => import("@pages/Booking"));
const BookingView = lazy(() => import("@pages/Booking/View"));
const BookingChatPage = lazy(() => import("@pages/Booking/Chat"));
const Review = lazy(() => import("@pages/Review"));
const Safety = lazy(() => import("@pages/Safety"));
const DriverReport = lazy(() => import("@pages/DriverReport"));
const WalletPage = lazy(() => import("@pages/Wallet"));
const TransactionPage = lazy(() => import("@pages/Transaction"));
const WithdrawalPage = lazy(() => import("@pages/Withdrawal"));
const EarningManagementPage = lazy(() => import("@pages/EarningManagement"));
const NotificationPage = lazy(() => import("@pages/Notification"));
const ContactEnquiryPage = lazy(() => import("@pages/ContactEnquiry"));

interface RouteConfig {
  path: string;
  title: string;
  component: ComponentType<object>;
}

const mainRoute: RouteConfig[] = [
  { path: "/", component: Home, title: "Dashboard" },
  { path: "/dashboard", component: Home, title: "Dashboard" },
  { path: "/profile", component: UserProfiles, title: "Profile" },
  { path: "/setting", component: Setting, title: "Setting" },
  {
    path: "/cms-management/email-template",
    component: CmsRedirectToEmailTemplatesTab,
    title: "EmailTemplates",
  },
  {
    path: "/cms-management/notification-template",
    component: CmsRedirectToNotificationTemplatesTab,
    title: "NotificationTemplates",
  },
  {
    path: "/cms-management/contact-enquiry",
    component: CmsRedirectToContactEnquiryTab,
    title: "ContactEnquiries",
  },
  {
    path: "/cms-management/sms-template",
    component: CmsRedirectToSmsTemplatesTab,
    title: "SmsTemplates",
  },
  {
    path: "/cms-management/blogs/add",
    component: BlogAddPage,
    title: "Add blog",
  },
  {
    path: "/cms-management/blogs/edit/:id",
    component: BlogEditPage,
    title: "Edit blog",
  },
  {
    path: "/cms-management/pages/add",
    component: PageAddPage,
    title: "Add page",
  },
  {
    path: "/cms-management/pages/edit/:id",
    component: PageEditPage,
    title: "Edit page",
  },
  {
    path: "/cms-management/faq/add",
    component: FaqAddPage,
    title: "Add FAQ",
  },
  {
    path: "/cms-management/faq/edit/:id",
    component: FaqEditPage,
    title: "Edit FAQ",
  },
  {
    path: "/cms-management",
    component: CmsManagement,
    title: "CMS Management",
  },
  {
    path: "/banner",
    component: BannerPage,
    title: "Banner",
  },
  {
    path: "/cms-management/banner",
    component: CmsRedirectToBannerTab,
    title: "Banner",
  },
  {
    path: "/cms-management/Page",
    component: CmsRedirectToPagesTab,
    title: "Pages",
  },
  {
    path: "/cms-management/page",
    component: CmsRedirectToPagesTab,
    title: "Pages",
  },
  {
    path: "/cms-management/faq",
    component: CmsRedirectToFaqTab,
    title: "Faq's",
  },
  {
    path: "/cms-management/report-issue",
    component: CmsRedirectToReportIssueTab,
    title: "Report Issue List",
  },
  {
    path: "/cms-management/trip-cancel-manager",
    component: CmsRedirectToTripCancelManagerTab,
    title: "Trip Cancel Manager",
  },
  {
    path: "/cms-management/promo-code",
    component: CmsRedirectToPromoCodeTab,
    title: "Promo Code",
  },
  {
    path: "/cms-management/state-management",
    component: CmsRedirectToStateManagementTab,
    title: "State Management",
  },
  {
    path: "/geo-fencing/add",
    component: GeoFenceFormPage,
    title: "Add geo-fence",
  },
  {
    path: "/geo-fencing/edit/:id",
    component: GeoFenceFormPage,
    title: "Edit geo-fence",
  },
  {
    path: "/geo-fencing",
    component: GeoFence,
    title: "Geo-Fencing Management",
  },
  {
    path: "/cms-management/training",
    component: CmsRedirectToTrainingTab,
    title: "Training",
  },
  {
    path: "/language",
    component: Language,
    title: "Language",
  },
  { path: "/admin", component: Admin, title: "Sub Admin" },
  { path: "/customer", component: Customer, title: "Customer" },
  { path: "/driver", component: Driver, title: "Driver" },
  { path: "/booking", component: Booking, title: "Booking Management" },
  {
    path: "/booking/chat/:bookingId",
    component: BookingChatPage,
    title: "Booking chat",
  },
  { path: "/booking/view/:id", component: BookingView, title: "Booking Details" },
  { path: "/review", component: Review, title: "Review List" },
  { path: "/safety", component: Safety, title: "Safety Alert Management" },
  { path: "/driver-report", component: DriverReport, title: "Driver Report Management" },
  { path: "/wallet", component: WalletPage, title: "Wallet Management" },
  { path: "/transaction", component: TransactionPage, title: "Transaction Management" },
  { path: "/withdrawal", component: WithdrawalPage, title: "Withdrawal Management" },
  {
    path: "/earning-management",
    component: EarningManagementPage,
    title: "Earning Management",
  },
  { path: "/notification", component: NotificationPage, title: "Notification Management" },
  { path: "/contact-enquiry", component: ContactEnquiryPage, title: "Contact enquiries" },
  { path: "/driver/add", component: DriverAdd, title: "Add Driver" },
  { path: "/driver/edit/:id", component: DriverAdd, title: "Edit Driver" },
  { path: "/driver/view/:id", component: DriverView, title: "View Driver" },
  {
    path: "/customer/add",
    component: CustomerAdd,
    title: "Add Customer",
  },
  {
    path: "/customer/edit/:id",
    component: CustomerView,
    title: "View Customer",
  },
  {
    path: "/vehicle-type",
    component: VehicleType,
    title: "Vehicle Type",
  },
  {
    path: "/fuel-type",
    component: FuelType,
    title: "Fuel Type",
  },
  {
    path: "/ride-type",
    component: RideType,
    title: "Ride Type",
  },
  {
    path: "/vehicle-catalog",
    component: VehicleCatalog,
    title: "Vehicle Catalog Management",
  },
  {
    path: "/vehicle-category",
    component: VehicleCategory,
    title: "Vehicle Types",
  },
  {
    path: "/vehicle",
    component: Vehicle,
    title: "Vehicle Management",
  },
  {
    path: "/vehicle/add",
    component: VehicleAdd,
    title: "Add Vehicle",
  },
  {
    path: "/vehicle/edit/:id",
    component: VehicleAdd,
    title: "Edit Vehicle",
  },
  {
    path: "/vehicle/view/:id",
    component: VehicleView,
    title: "View Vehicle",
  },
  {
    path: "/admin/add",
    component: AdminAdd,
    title: "Add Sub Admin",
  },
  {
    path: "/admin/edit/:id",
    component: AdminView,
    title: "View Admin",
  },
];

export default mainRoute;
